import React, { FC, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_PROJECTS } from "../../../graphql/queries";
import {
    Product,
    Project,
    ProjectsAdminData,
    User
} from "../../../models/types";
import { Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";

interface Props {
    user: User;
    updateProjects: (projectId: number) => void;
    filteredProducts?: Product[];
}

export const SelectableProjects: FC<Props> = ({
    user,
    updateProjects,
    filteredProducts
}) => {
    const { data: { allProjects } = {} } = useQuery<ProjectsAdminData>(
        GET_PROJECTS,
        {
            variables: {
                organizationId: Number(user.organization?.id)
            }
        }
    );

    const visibleProjects = filteredProducts
        ? allProjects?.filter((project: Project) =>
              filteredProducts.some(
                  (product: Product) =>
                      Number(product.id) === Number(project.product?.id)
              )
          )
        : allProjects;

    const selectedProject = (project: Project): boolean => {
        if (!user.projects) {
            return false;
        }
        return user.projects.some(
            (userProject: Project) =>
                Number(userProject.id) === Number(project.id)
        );
    };

    const alternatives = visibleProjects?.map(
        (project: Project, index: number) => (
            <li
                key={index}
                className={cx(
                    "list-group-item  mouseHover",
                    selectedProject(project)
                        ? "list-group-item-success"
                        : "list-group-item-secondary"
                )}
                onClick={() => updateProjects(Number(project.id))}
            >
                {project.id}: {project.name} ({project.product?.name})
            </li>
        )
    );

    const [showList, setShowList] = useState(true);

    return (
        <>
            {allProjects && allProjects?.length > 0 ? (
                <Row className="m-0 p-0 d-flex align-items-center mb-2">
                    <h4
                        className="mouseHover"
                        onClick={() => setShowList(!showList)}
                    >
                        Projects
                        <FontAwesomeIcon
                            icon={showList ? faChevronUp : faChevronDown}
                            style={{
                                color: "gray",
                                marginLeft: "6px",
                                fontSize: "16px"
                            }}
                        />
                    </h4>
                </Row>
            ) : null}
            {showList && filteredProducts && (
                <div className="text-inverse-50 bread-text px-2 pb-2">
                    Showing projects from searched products only.
                </div>
            )}
            {showList && (
                <ul className="list-group" id="selectable-projects-list">
                    {alternatives}
                </ul>
            )}
        </>
    );
};
